<template>
    <div class="langswitch light">
        <ul>
            <li class="langswitch-item" v-for="lang in languages">
                <a 
                  class="langswitch-link" 
                  :class="{'active': this.$i18n.locale === lang}"
                  v-on:click="changeLocale(lang)"
                  rel="alternate" 
                  :hreflang="lang" 
                  href="#">
                  {{ lang.toUpperCase() }}
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
//    import moment from 'moment';
    import { loadLoginAsync } from '../../../i18n';
    export default {
        name: 'loginlangswitch',
        props:{
            
        },
        methods:{
            changeLocale(locale) {
                loadLoginAsync(locale).then(()=>{
//                    moment().locale(locale);
                    this.$i18n.locale = locale;
                    window.langKey = locale;
                    const html = document.documentElement;
                    html.setAttribute('lang', locale);
                    localStorage.setItem('selectedLang', locale);
                });
            }
        },
        data(){
            return{
                languages: window.languages
            };
        },
        mounted() {
        }
    }
</script>


